(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/utils.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const jupiter = svs.core.jupiter;
const {
  API_PATHS
} = svs.lyckoplatsen.components.shared_constants;
const fetchNewDates = async (year, month) => {
  try {
    const options = {
      path: API_PATHS.datePicker(year, month),
      method: 'GET'
    };
    const {
      response
    } = await jupiter.callAsync(options);
    return response;
  } catch (e) {
    svs.lyckoplatsen.logger.warn('Failed to get datePicker', e);
    return [];
  }
};
async function fetchResult(product, drawNumber) {
  try {
    const {
      response
    } = await jupiter.callAsync({
      path: API_PATHS.resultByDrawId(product, drawNumber),
      method: 'GET'
    });
    return response.result;
  } catch (e) {
    svs.lyckoplatsen.logger.info('Failed to get result', e);
  }
}
async function fetchSpan(span) {
  try {
    const {
      response
    } = await jupiter.callAsync({
      path: API_PATHS.resultsBySpan(span),
      method: 'GET'
    });
    return response.spanResults;
  } catch (e) {
    svs.lyckoplatsen.logger.info('Failed to get result', e);
  }
}
const memoFetchNewDates = _.memoize(fetchNewDates, (year, month) => "".concat(year, "-").concat(month));
const memoFetchResult = _.memoize(fetchResult, (product, drawNumber) => "".concat(product, "-").concat(drawNumber));
const memoFetchSpan = _.memoize(fetchSpan, span => "".concat(span));
const formatAvailableDates = _ref => {
  let {
    resultDates,
    year,
    month
  } = _ref;
  const datesInMonth = {};
  resultDates === null || resultDates === void 0 || resultDates.forEach(resultDate => {
    const date = new Date(resultDate.date);
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    if (y === parseInt(year, 10) && m === parseInt(month, 10)) {
      const dateInMonth = date.getDate();
      if (!datesInMonth[dateInMonth]) {
        datesInMonth[dateInMonth] = [];
      }
      datesInMonth[dateInMonth].push(resultDate);
    }
  });
  return datesInMonth;
};
const noAdjacent = _ref2 => {
  let {
    resultArray,
    topValue
  } = _ref2;
  const result = new Array(resultArray.length);
  const nonTopValues = [];
  for (let i = 0; i < resultArray.length; i++) {
    if (resultArray[i] === topValue) {
      result[i] = resultArray[i];
      continue;
    }
    nonTopValues.push(resultArray[i]);
  }
  const frequencyMap = new Map();
  for (const value of nonTopValues) {
    frequencyMap.set(value, (frequencyMap.get(value) || 0) + 1);
  }
  let frequencyArray = [...frequencyMap.entries()].sort((_ref3, _ref4) => {
    let [aValue, aFrequency] = _ref3;
    let [bValue, bFrequency] = _ref4;
    return bFrequency - aFrequency || aValue - bValue;
  });
  const reordered = [];
  const leftovers = [];
  let lastPlaced = null;
  function pickNext() {
    frequencyArray.sort((_ref5, _ref6) => {
      let [aValue, aFrequency] = _ref5;
      let [bValue, bFrequency] = _ref6;
      return bFrequency - aFrequency || aValue - bValue;
    });
    for (let i = 0; i < frequencyArray.length; i++) {
      const [value, frequency] = frequencyArray[i];
      if (frequency > 0 && value !== lastPlaced) {
        frequencyArray[i] = [value, frequency - 1];
        return value;
      }
    }
    return null;
  }
  while (frequencyArray.length > 0) {
    const nextValue = pickNext();
    if (nextValue === null) {
      break;
    }
    reordered.push(nextValue);
    lastPlaced = nextValue;
    frequencyArray = frequencyArray.filter(_ref7 => {
      let [, frequency] = _ref7;
      return frequency > 0;
    });
  }
  frequencyArray.forEach(_ref8 => {
    let [value, frequency] = _ref8;
    while (frequency-- > 0) {
      leftovers.push(value);
    }
  });
  const mergedOrder = reordered.concat(leftovers);
  let index = 0;
  for (let i = 0; i < result.length; i++) {
    if (result[i] === undefined) {
      result[i] = mergedOrder[index++];
    }
  }
  return result;
};
const getDistributionArray = _ref9 => {
  let {
    winPlan,
    win,
    drawNumber
  } = _ref9;
  const COLORS = {
    even: '#2073E5',
    odd: '#1047B8',
    special: '#001932'
  };
  const totalItems = 40;
  const items = winPlan.map(item => _objectSpread(_objectSpread({}, item), {}, {
    probability: parseFloat(item.probability.replace(',', '.')),
    amountValue: parseFloat(item.amountSek.replace(',', '.'))
  }));
  const sortedByAmount = [...items].sort((a, b) => a.amountValue - b.amountValue);
  const lowestAmountSek = parseInt(sortedByAmount[0].amountSek, 10);
  const counts = items.map(item => Math.round(item.probability / 100 * totalItems));
  const remainder = totalItems - counts.reduce((sum, c) => sum + c, 0);
  let result = items.flatMap((item, i) => Array(counts[i]).fill(parseInt(item.amountSek, 10)));
  result = result.concat(Array(remainder).fill(lowestAmountSek));
  const topValueItem = sortedByAmount[sortedByAmount.length - 1];
  const topValue = parseInt(topValueItem.amountSek, 10);
  const topValues = result.filter(v => v === topValue);
  const topCount = topValues.length;
  if (topCount > 0) {
    const others = result.filter(v => v !== topValue);
    for (let i = others.length - 1; i > 0; i--) {
      const rand = Math.floor(Math.random() * (i + 1));
      [others[i], others[rand]] = [others[rand], others[i]];
    }
    const newResult = new Array(totalItems).fill(null);
    for (let i = 0; i < topCount; i++) {
      newResult[Math.round(i * totalItems / topCount)] = topValue;
    }
    let otherIndex = 0;
    for (let i = 0; i < newResult.length; i++) {
      if (newResult[i] === null) {
        newResult[i] = others[otherIndex++];
      }
    }
    result = noAdjacent({
      resultArray: newResult,
      topValue
    });
  }
  const distribution = result.map((value, index) => {
    let color = index % 2 === 0 ? COLORS.even : COLORS.odd;
    if (value === topValue) {
      color = COLORS.special;
    }
    return {
      value,
      isWin: false,
      color
    };
  });
  const winnableValues = distribution.filter(_ref0 => {
    let {
      value
    } = _ref0;
    return value === win;
  });
  const randomWinner = drawNumber * 2654435761 >>> 0;
  winnableValues[randomWinner % winnableValues.length].isWin = true;
  return distribution;
};
setGlobal('svs.lyckoplatsen.utils.page_result', {
  memoFetchNewDates,
  formatAvailableDates,
  memoFetchResult,
  memoFetchSpan,
  getDistributionArray
});

 })(window);